import styled from 'styled-components';

const Endpoint = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100px;
  cursor: pointer;

  &.start {
    border: 2px solid ${(props) => props.theme.colors.text};
    background: ${(props) => props.theme.colors.background_dashboard};
  }

  &.end {
    border: 2px solid ${(props) => props.theme.colors.text};
    background: ${(props) => props.theme.colors.green};
  }
`;

const Stop = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 100px;
  border: 1px solid ${(props) => props.theme.colors.black};
  background: ${(props) => props.theme.colors.main_cta};
  cursor: pointer;
`;

const TripCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 10px;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.widget_background};
  border: 1px solid ${(props) => props.theme.colors.outline};
  box-shadow: ${(props) => props.theme.shadows.dropdown};
  white-space: nowrap;
  pointer-events: none;

  .title {
    color: ${(props) => props.theme.colors.text};
    font-size: 12px;
    font-weight: 500;
  }

  .hint {
    color: ${(props) => props.theme.colors.inactive};
    font-size: 10px;
  }
`;

export default { Endpoint, Stop, TripCard };
